// extracted by mini-css-extract-plugin
export default {"label":"switchComponent_label__NnpZw"};